import { render, staticRenderFns } from "./NavId.vue?vue&type=template&id=1c763930&"
import script from "./NavId.vue?vue&type=script&lang=js&"
export * from "./NavId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports